



































































import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { IconSize } from '@getaccept/lib-ui';
import type { ChatParticipant, LastReadBy, Message } from '../types';
import { BaseChatCompositionApi } from '../composition/chat-composition-api';
import ChatMessageSender from './ChatMessageSender.vue';
import ChatMessageOther from './ChatMessageOther.vue';
import ChatTimestamp from './ChatTimestamp.vue';
import MessageReadBy from './MessageReadBy.vue';
import ChatReplyMessage from './ChatReplyMessage.vue';

export default defineComponent({
  name: 'ChatMessage',
  components: {
    ChatMessageSender,
    ChatMessageOther,
    ChatReplyMessage,
    ChatTimestamp,
    MessageReadBy,
  },
  props: {
    user: {
      type: Object as PropType<User>,
      default: undefined,
    },
    recipients: {
      type: Array as PropType<Array<Recipient>>,
      default: () => [],
    },
    message: {
      type: Object as PropType<Message>,
      default: undefined,
    },
    messages: {
      type: Array as PropType<Array<Message>>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<ChatParticipant>,
      default: undefined,
    },
    lastReads: {
      type: Array as PropType<Array<LastReadBy>>,
      default: () => [],
    },
  },
  emits: ['read', 'delete', 'reply'],
  setup(props, { emit }) {
    const { recipients, user, message, messages, lastReads, owner } = toRefs(props);
    const messageState = BaseChatCompositionApi.getMessageState(
      message.value,
      user.value,
      recipients.value,
      messages.value,
      owner.value
    );

    const handleRead = () => {
      emit('read', message.value.id);
    };

    const handleDelete = (): void => {
      emit('delete', message.value.id);
    };

    const handleReply = (): void => {
      emit('reply', message.value);
    };

    const messageLastReads = computed(() => {
      return lastReads.value.filter(({ messageId }: LastReadBy) => messageId === message.value.id);
    });

    return {
      ...toRefs(messageState),
      handleRead,
      messageLastReads,
      handleDelete,
      IconSize,
      handleReply,
    };
  },
});
